<template>
  <svg
    width="84"
    height="75"
    viewBox="0 0 84 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.70257 49.7293C-4.66505 39.0096 13.0048 4.99512 38.0371 0.69545C66.1322 -4.13431 85.8636 16.9223 80.9749 41.2184C75.5856 68.0177 40.2459 81.3879 30.174 71.905C24.2546 66.3096 34.1203 59.4772 26.8462 52.586C19.5721 45.7242 12.0035 54.7652 6.70257 49.7588V49.7293Z"
      fill="#F9F9FB"
    />
    <path
      d="M75 12L67 12"
      stroke="#B0B0D3"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M71 16V8"
      stroke="#B0B0D3"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M81 32C82.1046 32 83 31.1046 83 30C83 28.8954 82.1046 28 81 28C79.8954 28 79 28.8954 79 30C79 31.1046 79.8954 32 81 32Z"
      stroke="#797997"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M31.9104 18.1083L65.6317 25.7267C67.9613 26.2582 69.4174 28.6377 68.8932 31L63 57C62.4758 59.3623 60.3296 60.4232 58 59.8917L24 52C21.6703 51.4685 20.4758 49.3623 21 47L27 21C27.5241 18.6377 29.5808 17.5767 31.9104 18.1083Z"
      fill="white"
      stroke="#B0B0D3"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27 21C27.5211 18.6292 29.6838 17.4666 32 18L65.6512 25.7546C67.9674 26.288 69.415 28.6292 68.8938 31"
      fill="#EEEEF4"
    />
    <path
      d="M27 21C27.5211 18.6292 29.6838 17.4666 32 18L65.6512 25.7546C67.9674 26.288 69.415 28.6292 68.8938 31"
      stroke="#797997"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path d="M68.9 31L44 42L27 21" fill="#EEEEF4" />
    <path
      d="M69.3041 31.9147C69.8093 31.6915 70.0379 31.1011 69.8147 30.5959C69.5915 30.0907 69.0011 29.8621 68.4959 30.0853L69.3041 31.9147ZM44 42L43.2228 42.6292C43.5069 42.9802 43.991 43.0972 44.4041 42.9147L44 42ZM27.7772 20.3708C27.4297 19.9415 26.8001 19.8753 26.3708 20.2228C25.9415 20.5703 25.8753 21.1999 26.2228 21.6292L27.7772 20.3708ZM68.4959 30.0853L43.5959 41.0853L44.4041 42.9147L69.3041 31.9147L68.4959 30.0853ZM44.7772 41.3708L27.7772 20.3708L26.2228 21.6292L43.2228 42.6292L44.7772 41.3708Z"
      fill="#797997"
    />
    <path
      d="M10.531 30.0274C10.531 30.0274 10.5015 30.0274 10.4721 30.0274C9.91253 30.8226 9.32353 32.1184 8.35169 32.2067C7.37985 32.2951 6.90865 32.1184 6.26075 31.4999C5.61286 30.8815 5.43616 30.1747 5.31836 29.1734C5.20056 28.1721 5.49506 26.8469 6.05461 25.9339C6.5847 25.021 7.73324 24.5498 8.46949 24.4614C9.20573 24.3731 9.23518 24.5203 9.64748 24.6676C10.0892 24.8443 10.0009 25.2271 10.3543 25.4038C10.3837 25.4038 10.3543 25.4627 10.3837 25.4038C10.5015 25.1093 10.3837 24.7559 10.3837 24.4025C10.3837 24.0491 10.531 24.0786 10.8844 23.9608C11.2378 23.8135 11.4439 24.4025 11.4439 24.432C11.3261 25.1977 11.4439 28.8789 11.4439 28.9378C11.5617 30.263 12.0329 30.852 12.8575 30.8226C13.6821 30.7931 13.9766 30.4397 14.3594 29.674C14.7423 28.9083 14.9484 28.2899 14.9779 27.0825C15.0073 25.875 14.5656 24.108 13.2109 23.1362C11.8562 22.1938 10.207 21.487 8.32224 21.6342C6.43745 21.7815 4.58212 22.8711 3.46303 24.4025C2.34393 25.9339 2.04944 27.7304 2.16723 29.4679C2.28503 31.2054 3.08018 32.5896 4.34652 33.7087C5.58341 34.8277 7.61544 35.1517 9.05848 35.0633C10.5015 34.975 11.1494 34.5038 12.3569 34.0032C12.5041 33.9443 12.9753 33.8854 13.0637 34.2682C13.1226 34.5038 12.1802 35.1811 11.4145 35.4756C10.6193 35.7701 9.82418 36.0352 9.11738 36.1235C7.64489 36.2708 4.96496 35.829 3.58082 34.5333C2.19668 33.2375 1.10704 31.7061 1.01869 29.6446C0.930344 27.6126 1.10704 25.5511 2.60898 23.7841C4.11092 22.0171 5.81901 21.1042 8.46949 20.633C10.0303 20.3679 12.5041 21.222 13.9766 22.341C15.4196 23.4601 16.1264 25.7867 16.0086 27.2592C15.8908 28.7316 15.8025 29.3206 15.3018 30.3514C14.7717 31.3527 14.1533 31.7355 13.0637 31.8533C11.974 31.9711 11.3261 30.7048 10.5899 30.0569L10.531 30.0274ZM8.67564 25.4627C7.73324 25.5511 7.43875 25.9339 6.997 26.6113C6.55525 27.2886 6.4669 28.4077 6.5258 29.1145C6.5847 29.8213 6.7025 30.263 7.08535 30.7048C7.49765 31.1171 7.76269 31.2643 8.41059 31.176C9.05848 31.1171 9.61803 30.7637 9.94198 29.998C10.2659 29.2028 10.3837 28.1426 10.3248 27.1708C10.2659 26.199 9.61803 25.4038 8.67564 25.4922V25.4627Z"
      fill="#797997"
      stroke="#797997"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>